"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _constants = require("@seedlang/constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
var EvaluateButtonsWrapper = function EvaluateButtonsWrapper(Component) {
  var _class, _class2;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2() {
      _classCallCheck(this, _class2);
      return _callSuper(this, _class2, arguments);
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "onButtonClick",
      value: function onButtonClick(button) {
        var params = {
          score: button.score,
          skipSoundEffect: button.skipSoundEffect,
          xp: button.xp,
          xpXPos: button.xpXPos,
          retire: button.retire
        };
        if (this.props.advanceCard) {
          this.props.advanceCard(this.props.card, this.props.cardState, this.props.userCard, params);
        } else {
          _state.DeckUI.advanceCard(this.props.card, this.props.cardState, this.props.userCard, params);
        }
      }
    }, {
      key: "disabled",
      get: function get() {
        return !this.props.alwaysEnable && (this.props.disabled || _state.DeckUI.cardIsAnimating || !this.props.cardState.revealed && _state.DeckUI.canRecordMedia);
      }
    }, {
      key: "showEasyButton",
      get: function get() {
        var _this$props$cardState, _this$props$userCard;
        return ((_this$props$cardState = this.props.cardState) === null || _this$props$cardState === void 0 ? void 0 : _this$props$cardState.revealed) && ((_this$props$userCard = this.props.userCard) === null || _this$props$userCard === void 0 ? void 0 : _this$props$userCard.correct) || !this.props.card.genderCard && !this.props.card.pluralCard && !this.vocabTextEntryCard && !this.props.card.exerciseCard && !this.props.card.wordOptionsCard && !this.props.card.triviaCard && !this.props.card.conjugationCard;
      }
    }, {
      key: "vocabTextEntryCard",
      get: function get() {
        return this.props.card.vocabWordTranslateCard && !_state.DeckUI.vocabCardUsesAudio || this.props.card.vocabSentenceTranslateCard && !_state.DeckUI.vocabCardUsesAudio;
      }
    }, {
      key: "easyButtonRetiresCard",
      get: function get() {
        return !_state.DeckUI.user.disableRetiringReviews && !this.props.card.retired && this.props.card.reviewInterval(_constants.Constants.EASY_SCORE) > _state.DeckUI.user.daysUntilReviewRetired;
      }
    }, {
      key: "hardButtonSubText",
      get: function get() {
        return this.props.card.formattedReviewInterval(_constants.Constants.BAD_SCORE);
      }
    }, {
      key: "goodButtonSubText",
      get: function get() {
        return this.props.card.formattedReviewInterval(_constants.Constants.GOOD_SCORE);
      }
    }, {
      key: "easyButtonSubText",
      get: function get() {
        return this.easyButtonRetiresCard ? null : this.props.card.formattedReviewInterval(_constants.Constants.EASY_SCORE);
      }
    }, {
      key: "onHardClick",
      value: function onHardClick() {
        var params = {
          score: _constants.Constants.BAD_SCORE,
          skipSoundEffect: true,
          xp: 0,
          xpXPos: _state.DeckUI.layout.quarterDeckWidth * 3,
          retire: false
        };
        if (this.props.advanceCard) {
          this.props.advanceCard(this.props.card, this.props.cardState, this.props.userCard, params);
        } else {
          _state.DeckUI.advanceCard(this.props.card, this.props.cardState, this.props.userCard, params);
        }
      }
    }, {
      key: "onGoodClick",
      value: function onGoodClick() {
        var params = {
          score: _constants.Constants.GOOD_SCORE,
          xp: 2,
          xpXPos: _state.DeckUI.layout.quarterDeckWidth * 1,
          retire: false
        };
        if (this.props.advanceCard) {
          this.props.advanceCard(this.props.card, this.props.cardState, this.props.userCard, params);
        } else {
          _state.DeckUI.advanceCard(this.props.card, this.props.cardState, this.props.userCard, params);
        }
      }
    }, {
      key: "onEasyClick",
      value: function onEasyClick() {
        var params = {
          score: _constants.Constants.EASY_SCORE,
          xp: 2,
          xpXPos: _state.DeckUI.layout.quarterDeckWidth * 1,
          retire: this.easyButtonRetiresCard
        };
        if (this.props.advanceCard) {
          this.props.advanceCard(this.props.card, this.props.cardState, this.props.userCard, params);
        } else {
          _state.DeckUI.advanceCard(this.props.card, this.props.cardState, this.props.userCard, params);
        }
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          disabled: this.disabled,
          showEasyButton: this.showEasyButton,
          easyButtonRetiresCard: this.easyButtonRetiresCard,
          hardButtonSubText: this.hardButtonSubText,
          goodButtonSubText: this.goodButtonSubText,
          easyButtonSubText: this.easyButtonSubText,
          onHardClick: this.onHardClick,
          onGoodClick: this.onGoodClick,
          onEasyClick: this.onEasyClick
        }));
      }
    }]);
  }(_react["default"].Component), _applyDecoratedDescriptor(_class2.prototype, "onButtonClick", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onButtonClick"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "disabled", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "disabled"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showEasyButton", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showEasyButton"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "vocabTextEntryCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "vocabTextEntryCard"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "easyButtonRetiresCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "easyButtonRetiresCard"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hardButtonSubText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hardButtonSubText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "goodButtonSubText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "goodButtonSubText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "easyButtonSubText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "easyButtonSubText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onHardClick", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onHardClick"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onGoodClick", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onGoodClick"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onEasyClick", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onEasyClick"), _class2.prototype), _class2)) || _class;
};
EvaluateButtonsWrapper.displayName = 'EvaluateButtonsWrapper';
var _default = exports["default"] = EvaluateButtonsWrapper;